/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Lists_TitleInputs */



/**
* | output |
* | --- |
* | "Wishlists & Tradelists" |
*
* @param {Help_Article_Lists_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_lists_title = /** @type {((inputs?: Help_Article_Lists_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Lists_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wunschlisten & Tauschlisten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Listes de souhaits et listes d'échange")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("心愿单与交换清单")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("願望清單與交換清單")
	if (locale === "ko") return /** @type {LocalizedString} */ ("위시리스트와 교환 목록")
	return /** @type {LocalizedString} */ ("Wishlists & Tradelists")
});